<div class="one-week-free-agency">
  <div class="plans-container">

    <div class="plans-wrap"
         [class.two-column]="subscriptions.length === 2"
         [class.one-column]="subscriptions.length === 1"
         [class.responsive-stacked]="shouldStackPlans">
      <ng-container *ngFor="let plan of subscriptions">
        <div class="plan-item {{plan.tabCategory}}" [style.height]="!!couponPercent && '738px'">
          <span *ngIf="plan.category === 'enterprise'" class="db-badge">VPS</span>
          <div class="plan-item-header">
            <h3>{{ plan?.category === 'enterprise' ? 'Agency Ultimate' : plan.plan.title }}</h3>
            <div class="plan-item-price">
              ${{ (plan.plan.planPrice * (100 - (plan?.type === UserSubscriptionCategory.DedicatedVM ? 0 : couponPercent)) / 100) / plan.plan.periodNumber | DbNumberFormatPipe:  'ceil' }}<span>/mo</span></div>
            <div class="plan-item-billed-period" [style.height]="!!couponPercent && '42px'">
              <p *ngIf="applyCouponForPlatform && couponPercent && plan?.type !== UserSubscriptionCategory.DedicatedVM"
                 class="mb4 mt6">{{couponPercent}}% off on your first payment</p>
              @if (showSwitchAnnual && periodSwitch === 12 && isCurrentPlan(plan)) {
                <span>Billed ${{annualPrice}} annually</span>
              } @else {
                <span class="mb24">Billed {{ plan.plan.periodNumber === 12 ? 'annually' : 'monthly' }}</span>
              }
            </div>
            <div class="plan-item-main-features">
              <div class="plan-item-main-feature" [class.vps]="plan?.category === 'enterprise'">
                @if (plan?.category === 'enterprise') {
                  <div class="db-website-count-wrapper">
                    @for (count of counts; track count) {
                      <span
                        [ngClass]="{ 'db-selected': selectedCount === count }"
                        (click)="selectCount(count)">
                      <ng-container *ngIf="selectedCount === count">
                         Up to {{ count }} websites
                      </ng-container>
                      <ng-container *ngIf="selectedCount !== count">
                        {{ count }}
                      </ng-container>
                    </span>
                    }

                  </div>
                } @else {
                  <i class="db-icon db-icon-ds-globus"></i>
                  <span>{{ plan?.plan?.planAdditionalDomainCount }}  websites</span>
                }
              </div>

              <div class="plan-item-main-feature">
                <i class="db-icon db-icon-ds-ai-generation"></i>
                <span>{{ plan?.plan?.services?.ai_builder?.regeneration_count?.parameter_value }} monthly AI website generations</span>
              </div>
              <div class="plan-item-main-feature">
                @if (plan?.category !== 'enterprise') {
                  <div class="db-data-locations">
                    <i class="db-icon db-icon-ds-location-pin-stroke"></i>
                    12 data center locations
                  </div>
                } @else {
                  <div class="db-data-locations enterprise">
                    <div class="dropdown-header" (click)="toggleDropdown()">
                      <div>
                        <i class="db-icon db-icon-ds-location-pin-stroke"></i>
                        <span>{{ selectedLocation }}</span>
                      </div>
                      <i class="db-icon db-icon-ds-arrow-small" [ngClass]="{ rotate: isDropdownOpen }"></i>
                    </div>
                    <div class="dropdown-list-vps" *ngIf="isDropdownOpen">
                      <div
                        *ngFor="let location of dataCenterLocations"
                        [ngClass]="{ selected: selectedLocation === location }"
                        (click)="selectLocation(location)">
                        <span>{{ location }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            @if (isCurrentPlan(plan)) {
              @if (currentSubscription?.plan?.price === currentSubscription?.plan?.planPrice &&
              currentSubscription?.periodNumber < 6 &&
              periodSwitch === 12 &&
              !currentSubscription?.plan?.hasAddons &&
              !currentSubscription?.isExpired &&
              plan?.category !== 'enterprise' &&
              ![userSubscriptionStatus?.canceled, userSubscriptionStatus?.failed, userSubscriptionStatus?.expired].includes(currentSubscription?.status)) {
                <button class="ds-btn-max ds-btn-black" (click)="switchToAnnual()">
                  <span>Switch to Annual</span>
                </button>
              } @else {
                <button class="ds-btn-max ds-btn-gray ds-btn-disabled">
                  <span>Current plan</span>
                </button>
              }
            } @else {
              <button class="ds-btn-max {{plan?.category === 'enterprise' && !currentSubscription?.trialClient ? 'ds-btn-purple-blue' : 'ds-btn-black'}}"
                      (click)="chooseSubscription(plan)">
                <span>{{ canSwitch && (plan?.category !== 'enterprise') && !invitedUser ? 'Switch plan' : plan?.category === 'enterprise' ?
                    currentSubscription?.trialClient ? 'Buy now' : 'Talk to sales' : 'Upgrade now' }}</span>
              </button>
            }

          </div>
          <div class="plan-item-secondary-features">
            <ng-container *ngFor="let features of secondaryFeatures">
              <ng-container *ngFor="let feature of features[plan.category]">
                <div class="plan-item-secondary-feature" [class.has-video]="feature.tooltip"
                     [dsTooltipSize]="'small'"
                     [dsTooltipMode]="'hoverStatic'" [dsTooltipVisible]="feature.tooltip" [dsTooltip]="copilot"
                     [dsTooltipWithVideo]="true"
                     [dsTooltipPosition]="'bottom'"
                     [dsTooltipAlign]="'left'"
                     [hostClass]="'cover-all'">
                  <div class="plan-item-secondary-feature-wrapper">
                    <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                    <span class="title" [innerHTML]="feature.title"></span>
                    <i class="db-icon db-icon-ds-play-small" *ngIf="feature.tooltip"></i>
                  </div>
                  <span
                    class="plan-item-secondary-feature-number"
                    *ngIf="feature.limitNumber">{{ feature.limitNumber }}</span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="features-container">
    <h2>All plans include</h2>
    <div class="features-grid">
      <ng-container *ngFor="let column of allPlansFeatures">
        <div class="features-category-column">
          <ng-container *ngFor="let category of column">
            <div class="features-category">
              <h3>{{ category.title }}</h3>
              <ul>
                <li *ngFor="let item of category.items">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                  <span
                    class="features-category-item-text"
                    [innerHTML]="item"
                  ></span>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="additional-wrapper">
    <h2>Extra usage</h2>
    <div class="additional-features-list">
      <div class="additional-feature-item" *ngFor="let addOn of addOnsFeatures">
        <div class="feature-title"
             [innerHTML]="'<p>' + addOn.title  + '</p>' + '<span>' + (addOn?.hasSymbol ? '*': '') + '</span>' | safeHtml"></div>
        <div class="feature-price" [innerHTML]="addOn.price"></div>
        <div class="feature-description" [innerHTML]="'<p>' + addOn.description + '</p>' | safeHtml"></div>
      </div>
    </div>
    <p><span>*</span> Per request for Agency Ultimate</p>
  </div>
</div>

<ng-template #copilot>
  <div class="video-tooltip">
    <p>EXPLORE AI COPILOT FEATURES</p>
    <!-- Image Instead of Video -->
    <div class="video-thumbnail" (click)="openVideoPopup()">
      <img src="assets/images/upgrade-plan/copilot_iframe.jpg"
           alt="Explore AI Copilot Features"/>
      <i class="db-icon db-icon-ds-media-play"></i>
    </div>
  </div>

</ng-template>
